// Central copy dictionary for the site.
//
// Only `en` is filled in for now. `pt` and `nl` are stubbed out with the same
// key shape so the navbar language dropdown has something to switch to later
// — any key left blank (or a language missing entirely) falls back to `en`
// automatically, see `LanguageContext.js`.

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "nl", label: "Nederlands" },
];

export const DEFAULT_LANGUAGE = "en";

const translations = {
  en: {
    nav: {
      shop: "Shop",
      catering: "Catering",
    },
    hero: {
      titleLine1: "Brazilian roots",
      titleLine2: "on your table",
      ctaPrimary: "Get in touch with us",
      ctaSecondary: "Follow us on Instagram",
    },
    cateringPage: {
      title: "Catering",
      comingSoon:
        "Catering details are coming soon. Reach out on Instagram to start the conversation.",
      cta: "Get in touch with us",
      back: "Back home",
    },
    footer: {
      tagline: "Brazilian roots.",
      rights: "All rights reserved.",
    },
  },
  pt: {
    // TODO: Portuguese copy
  },
  nl: {
    // TODO: Dutch copy
  },
};

export default translations;
